/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M12,13.913 C12.881,13.913 12.294,14.5 14.055,14.5 C15.816,14.5 17.576,10.979 17.576,8.631 C17.576,6.282 16.108,4.522 14.347,4.522 C12.586,4.522 12.587,5.108 12,5.108 C11.413,5.108 10.848,4.5 9.5,4.5 C9.5,9 6.424,8.63 6.424,8.63 C6.424,10.979 8.185,14.5 9.945,14.5 C11.707,14.5 11.119,13.913 12,13.913 Z" />
      <path d="M12,5.108 L12,3.674 C12,3.028 11.472,2.5 10.826,2.5 L9.652,2.5" />
      <path d="M13.358,3.142 C14.817,3.142 16,1.959 16,0.5 C14.541,0.5 13.358,1.684 13.358,3.142 Z" />
      <path d="M0.5,22.5 L5.5,22.5 C6.604,22.5 7.5,21.604 7.5,20.5 L7.5,18.5 C7.5,17.396 6.604,16.5 5.5,16.5 L0.5,16.5" />
      <path d="M5.5,22.5 L22,22.5 C23.104,22.5 23.5,21.604 23.5,20.5 L23.5,18.5 C23.5,17.396 23.104,16.5 22,16.5 L5.5,16.5" />
      <path d="M19.5,16.5 L19.5,22.5" />
      <path d="M17.5,16.5 L17.5,22.5" />
      <path d="M13.5,16.5 L13.5,22.5" />
      <path d="M11.5,16.5 L11.5,22.5" />
      <path d="M5.5,20.5 L1.5,20.5" />
      <path d="M5.5,18.5 L1.5,18.5" />
    </g>
  </svg>
);

export default Icon;
